import { defineComponent } from '~/utils/alpine_types'

export const nestedAttributes = defineComponent(() => ({
  nestedFieldsId: undefined as unknown as string,

  init() {
    this.nestedFieldsId = this.$id('nested-fields')
  },

  // Add a new set of nested fields from a pre-rendered template that has fields for a new record
  addFields() {
    const template = this.$root.querySelector(`template#${this.nestedFieldsId}`)
    if (!template) {
      console.error('No template found for new fields')
      return
    }

    const fields = template.innerHTML.replace(/NESTED_CHILD_INDEX/g, Date.now().toString())
    template.insertAdjacentHTML('beforebegin', fields)
  },

  // Hide existing fields that need to send a truthy `_destroy` value or remove new fields
  deleteFields(persisted: boolean, selector: string = 'fieldset') {
    const container = this.$el.closest(selector)
    if (!container || !(container instanceof HTMLElement)) {
      console.error('Container not found')
      return
    }

    persisted ? (container.hidden = true) : container.remove()
  },
}))
